export default "__VITE_ASSET__WddQVz____"